// package/server-ee/app/kubernetes/converters/shared.js
import _ from 'lodash-es';

/**
 * Shared utility functions for Kubernetes converters
 */
class KubernetesConverterHelper {
  /**
   * Set resource limits and requests on a container spec
   * @param {Object} payload - The payload object containing the container spec
   * @param {Object} application - The application object with resource settings
   * @param {string} containerPath - Path to the container in the payload (default: 'spec.template.spec.containers[0]')
   */
  static setResourceLimitsAndRequests(payload, application, containerPath = 'spec.template.spec.containers[0]') {
    if (application.MemoryLimit || application.CpuLimit || application.MemoryRequest || application.CpuRequest) {
      const resources = {};
      const limits = {};
      const requests = {};

      if (application.MemoryLimit) {
        limits.memory = application.MemoryLimit;
      }

      if (application.CpuLimit) {
        limits.cpu = application.CpuLimit;
      }

      if (application.MemoryRequest) {
        requests.memory = application.MemoryRequest;
      }

      if (application.CpuRequest) {
        requests.cpu = application.CpuRequest;
      }

      if (Object.keys(limits).length > 0) {
        resources.limits = limits;
      }

      if (Object.keys(requests).length > 0) {
        resources.requests = requests;
      }

      if (Object.keys(resources).length > 0) {
        _.set(payload, `${containerPath}.resources`, resources);
      }
    } else {
      _.unset(payload, `${containerPath}.resources`);
    }
  }
}

export default KubernetesConverterHelper;
